import {TranslationKeyForkygram} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_FORKYGRAM_EN: TranslationResource<TranslationKeyForkygram> = {
  translation: {
    'forkygram:accountUnavailable': 'This account is unavailable',
    'forkygram:authAccessHeader': 'Login',
    'forkygram:beingBlocked': 'There are no posts uploaded here yet.',
    'forkygram:blockYuser': 'Block Yuser',
    'forkygram:blockYuserAcc': 'Block Yuser Account',
    'forkygram:blockYuserAccSuccess': 'Account successfully blocked',
    'forkygram:blockYuserAccText': 'Are you sure want to block yuser account?',
    'forkygram:blockedDescription':
      'You can not see the photos or videos because you have blocked this yuser.',
    'forkygram:caption': 'Caption',
    'forkygram:captionInputPlaceholder':
      'Add a caption here (Max. 300 characters)',
    'forkygram:clearSearch': 'Clear all recent searches?',
    'forkygram:commentLimitPerDay':
      'Sorry! You can only leave {{comment_limit}} comments/day.',
    'forkygram:commentHeader': 'Comment ({{comment_count}})',
    'forkygram:commentHeader_plural': 'Comments ({{comment_count}})',
    'forkygram:commentPlaceholder': 'Comment as {{username}}',
    'forkygram:commentPlaceholder_GUEST':
      'Please log in or register to leave comments.',
    'forkygram:count': '{{count}}',
    'forkygram:count_B': '{{count}}B',
    'forkygram:count_K': '{{count}}K',
    'forkygram:count_M': '{{count}}M',
    'forkygram:countUploadDuration': '{{count}} seconds ago',
    'forkygram:countUploadDuration_day': '{{count}} days ago',
    'forkygram:countUploadDuration_hour': '{{count}} hours ago',
    'forkygram:countUploadDuration_minute': '{{count}} minutes ago',
    'forkygram:deletePostComment': 'Delete Comment',
    'forkygram:deletePostCommentMessage':
      'Are you sure want to delete this comment?',
    'forkygram:deletePostMessage': 'Are you sure want to delete this post?',
    'forkygram:deletePostTitle': 'Delete Post',
    'forkygram:emptyFeedMessage': 'There is no more content to show for now.',
    'forkygram:emptyFeedTitle': "Oops, looks like you've seen it all!",
    'forkygram:feedTabTitle': 'Feed',
    'forkygram:feedTabTitle_following': 'Following',
    'forkygram:feedTabTitle_fyp': 'ForYu',
    'forkygram:feedTabTitle_ugc': 'User Generated',
    'forkygram:follow': 'Follow',
    'forkygram:followBack': 'Follow Back',
    'forkygram:followRequest': 'Follow Requests',
    'forkygram:followRequestEmptyDescription':
      'People who request to follow you will appear here.',
    'forkygram:followRequestEmptyTitle': 'No follow requests at the moment.',
    'forkygram:followerCount': '<follow>{{follow}}</follow> Follower',
    'forkygram:followerCount_plural': '<follow>{{follow}}</follow> Followers',
    'forkygram:followers': 'Followers',
    'forkygram:following': 'Following',
    'forkygram:followingCount': '<follow>{{follow}}</follow> Following',
    'forkygram:fototreeTagMismatch': 'Please select a FotoTree from the list.',
    'forkygram:fototreeTagNotFound': 'We cannot find FotoTree {{tag_name}}',
    'forkygram:home': 'Home',
    'forkygram:hideReply': 'Hide replies',
    'forkygram:likes': 'Likes',
    'forkygram:likeLimitPerDay': 'Sorry! You can only like 1000 post/day.',
    'forkygram:likeLimitPerHour': 'Sorry! You can only like 350 post/hour.',
    'forkygram:logOutMessage': 'Are you sure you want to log out?',
    'forkygram:message': 'Message',
    'forkygram:myAccount': 'My Account',
    'forkygram:noPost': 'No Posts Yet',
    'forkygram:noPostDescription':
      "This yuser hasn't published anything here yet",
    'forkygram:post': 'Post',
    'forkygram:postDelete': 'Delete post',
    'forkygram:postEdit': 'Edit post',
    'forkygram:postEmptyButton': 'Upload Now',
    'forkygram:postEmptyDescription':
      "You haven't uploaded your moments yet. We're excited for your amazing moments.",
    'forkygram:postEmptyHeader': 'Your Moments',
    'forkygram:postPin': 'Pin post',
    'forkygram:postPinFailed': 'Maximum pinned content is 9.',
    'forkygram:postPinSuccess': 'Post pinned to your profile.',
    'forkygram:postShare': 'Share post',
    'forkygram:postUnpin': 'Unpin post',
    'forkygram:postUnpinSuccess': 'Post unpinned from your profile.',
    'forkygram:postUpdated': 'Post Updated',
    'forkygram:privateAccount': 'This Account is Private',
    'forkygram:privateAccountDescription':
      'Follow this account to view their activity.',
    'forkygram:removeFollower': 'Remove',
    'forkygram:removeFollowerDescription':
      "<username>@{{username}}</username> won't be notified that you removed them from your followers.",
    'forkygram:removeFollowerSuccess': 'Follower removed successfully.',
    'forkygram:removeFollowerTitle': 'Remove Follower?',
    'forkygram:reply': 'Reply',
    'forkygram:replying': 'Replying to',
    'forkygram:reportCancel': 'Report cancelled.',
    'forkygram:reportComment': 'Report Comment',
    'forkygram:reportComment_HATE SPEECH': 'Hate speech',
    'forkygram:reportComment_HARASSMENT': 'Bullying or harassment',
    'forkygram:reportComment_HARRASMENT': 'Bullying or harassment',
    'forkygram:reportComment_OTHER': 'Other issues',
    'forkygram:reportComment_SPAM': 'Spam comment',
    'forkygram:reportCommentAlreadyReported':
      'You already reported this comment.',
    'forkygram:reportCommentCancel': 'Report canceled.',
    'forkygram:reportCommentFailed':
      "There's a problem when reporting the comment.",
    'forkygram:reportCommentSuccess':
      'Thank you for reporting. The comment has been successfully reported.',
    'forkygram:reportOtherPlaceholder': 'Write your reason here...',
    'forkygram:reportPostFailed': "There's a problem when reporting the post.",
    'forkygram:reportPostSuccess':
      'Thank you for reporting. The post has been successfully reported.',
    'forkygram:reportYuser': 'Report Yuser',
    'forkygram:reportYuserFailed':
      "There's a problem when report this account.",
    'forkygram:reportYuserReason': 'Unknown',
    'forkygram:reportYuserReason_FAKE ACCOUNT':
      "It's pretending to be someone else",
    'forkygram:reportYuserReason_INAPPROPRIATE':
      'One of the contents posted should not be allowed',
    'forkygram:reportYuserReason_OTHER': 'Other',
    'forkygram:reportYuserSuccess':
      'Thank you for reporting. This account has been successfully reported.',
    'forkygram:searchFriends': 'Search Friends',
    'forkygram:searchFriendsNotFound':
      "Sorry! We cannot find the user you're looking for.",
    'forkygram:searchFriendsNotFoundSubtitle':
      'Please try again using another keyword.',
    'forkygram:shareYuser': 'Share Yuser',
    'forkygram:unblock': 'Unblock',
    'forkygram:unblockConfirmation': 'Are you sure to unblock this account?',
    'forkygram:unblockSuccessMessage': 'Account successfully unblocked',
    'forkygram:unblockYuser': 'Unblock Yuser',
    'forkygram:unfollowDescription':
      "You'll need to send a follow request again to regain access.",
    'forkygram:unfollowTitle': 'Unfollow This Private Account?',
    'forkygram:uploadEditThumbnail': 'Edit Thumbnail',
    'forkygram:uploadEditThumbnail_select': 'Select Thumbnail',
    'forkygram:uploadEditThumbnail_upload': 'Upload Thumbnail',
    'forkygram:uploadEditThumbnailUploadNew': 'Upload New Thumbnail',
    'forkygram:uploadEditThumbnailUploadValidation': '',
    'forkygram:uploadEditThumbnailUploadValidation_1':
      'JPG, JPEG, PNG, HEIC, HEIF',
    'forkygram:uploadEditThumbnailUploadValidation_2': 'Max Size {{size}} MB',
    'forkygram:uploadEditThumbnailUploadValidation_3':
      'Minimum Resolution {{width}}x{{height}} pixels',
    'forkygram:uploadHeader': 'Content Info',
    'forkygram:uploadInvalidImageFormat':
      'The image file is invalid or the image type is not allowed. Only files with the following extension are allowed: jpg, jpeg, png, heic, and heif',
    'forkygram:uploadInvalidVideoFormat':
      'The video file is invalid or the video type is not allowed. Only files with the following extension are allowed: mp4(mpeg-4), and mov',
    'forkygram:uploadLimitMessage':
      'You reached the post limit. Try again after {{value}} {{unit}}.',
    'forkygram:uploadLimitMessage_leaf':
      'You reached the leaf limit. Try again after {{value}} {{unit}}.',
    'forkygram:uploadMaxImageResolutionMessage':
      'Maximum image resolution is 25 megapixels',
    'forkygram:uploadMaxImageSizeMessage': 'Maximum image file size is 5 MB',
    'forkygram:uploadMaxVideoDurationMessage':
      'Maximum video length is 30 seconds',
    'forkygram:uploadMaxVideoSizeMessage': 'Maximum video file size is 30 MB',
    'forkygram:uploadMaxVideoWidthMessage':
      'Maximum video width is 1080 pixels',
    'forkygram:uploadMinImageResolutionMessage':
      'Minimum image resolution is 600x600 pixels',
    'forkygram:uploadPostActivateRoboyuBottomDesc':
      'When your RoboYu is activated, you can come back here to start uploading your content.',
    'forkygram:uploadPostActivateRoboyuUpperDesc':
      'You need to activate your RoboYu first before uploading your first content.',
    'forkygram:uploadSearchPeoplePlaceholder': 'Search by username',
    'forkygram:uploadSuccessMessage':
      'Congrats! The image has been successfully posted',
    'forkygram:uploadSuccessMessage_leaf': 'You have leaf-t a memory',
    'forkygram:uploadThumbnailFailed': 'Failed to upload thumbnail.',
    'forkygram:viewReply': 'View {{count}} more reply',
    'forkygram:viewReply_plural': 'View {{count}} more replies',
  },
}
